import { COLORS } from '@app/constants';
import { ArrowDown } from '@app/ui/iconComponents';
import { FC } from 'react';
import { DropdownIndicatorProps } from 'react-select';
import styled from 'styled-components';

const DropdownIndicator: FC<DropdownIndicatorProps> = ({
  children,
  cx,
  ...props
}) => {
  const { menuIsOpen, isWithoutArrow = false } = props.selectProps;

  return !isWithoutArrow ? (
    <Root $isOpened={menuIsOpen} {...props}>
      <ArrowDown color={menuIsOpen ? COLORS.primary300 : undefined} />
    </Root>
  ) : null;
};

export default DropdownIndicator;

interface StyleProps {
  $isOpened: boolean;
}

const Root = styled.div<StyleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;

  transform: ${({ $isOpened }) => $isOpened && 'rotate(180deg)'};
`;
